import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { CARGOCHIEF_KEYS, DEADHEAD_MSG } from '@domain/constants/app-variables';
import { UtilService } from '@service/util/util.service';
import { UserSettingsService } from '@service/userSettings/user-settings.service';
import { CapacitySearchFilterService } from '@service/capacitySearchFilter/capacity-search-filter.service';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-deadhead-sliders',
	templateUrl: './deadhead-sliders.component.html',
	styleUrls: ['./deadhead-sliders.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class DeadheadSlidersComponent implements OnInit {
	@Input() isLoadingSearchResults: boolean = true;
	@Input() lanePricing: any = null;
	@Input() showRecentTransactionsCard: boolean = false;
	@Input() originSliderDisabled: boolean = false;
	@Input() destinationSliderDisabled: boolean = false;

	@Output() sliderChange: EventEmitter<any> = new EventEmitter();

	sliderModel: any = {
		dho: null,
		dhd: null,
	};
	SLIDER_RANGE: any = {
		min: 5,
		max: 500,
	};
	CARGOCHIEF_KEYS = CARGOCHIEF_KEYS;
	SLIDER_STEP_SIZE = 5;
	environment = environment;
	DEADHEAD_MSG: string = DEADHEAD_MSG;

	constructor(
		public cargochief: Cargochief,
		public utilService: UtilService,
		public userSettings: UserSettingsService,
		private capacitySearchFilterService: CapacitySearchFilterService
	) {}

	ngOnInit() {
		this.initializeDeadhead();
	}

	initializeDeadhead() {
		const userDHO = this.userSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT;
		const userDHD = this.userSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT;
		const DHO = this.cargochief.getItem(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER),
			DHD = this.cargochief.getItem(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER);
		if (!this.utilService.isNullOrUndefined(userDHO)) {
			this.sliderModel.dho = userDHO;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			this.sliderModel.dho = JSON.parse(DHO);
		} else {
			this.sliderModel.dho = 10;
		}
		if (!this.utilService.isNullOrUndefined(userDHD)) {
			this.sliderModel.dhd = userDHD;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			this.sliderModel.dhd = JSON.parse(DHO);
		} else {
			this.sliderModel.dhd = 10;
		}
		// check from localstorage if deadhead filter exist, this is picked by request
		const { originDeadhead, destinationDeadhead } = this.capacitySearchFilterService.getDeadhead();
		if (originDeadhead) {
			this.sliderModel.dho = originDeadhead;
		}
		if (destinationDeadhead) {
			this.sliderModel.dhd = destinationDeadhead;
		}
	}

	sliderChanged(key, value) {
		this.cargochief.setItem({ [key]: value });
		this.sliderChange.emit();
	}

	sliderButtonClicked(key: string, ngModel: string, stepChanged) {
		if (
			+this.sliderModel[ngModel] + stepChanged >= this.SLIDER_RANGE.min &&
			+this.sliderModel[ngModel] + stepChanged <= this.SLIDER_RANGE.max
		) {
			this.sliderModel[ngModel] = +this.sliderModel[ngModel] + stepChanged;
			this.sliderChanged(key, this.sliderModel[ngModel]);
		}
	}

	isSearchRadiusvalid(): boolean {
		if (
			environment.SHOW_DEADHEAD_MSG &&
			!this.utilService.isNullOrUndefined(this.lanePricing) &&
			!this.utilService.isNullOrUndefined(this.lanePricing.searchRadius) &&
			this.showRecentTransactionsCard &&
			(this.sliderModel.dhd > this.lanePricing.searchRadius ||
				this.sliderModel.dho > this.lanePricing.searchRadius)
		) {
			this.DEADHEAD_MSG = this.DEADHEAD_MSG.replace('#radius#', this.lanePricing.searchRadius);
			return true;
		}
		return false;
	}
}
